const CustomPagination = ({ inputPayload, setInputPayload, totalCount }) => {
  const { pageNumber, pageSize } = inputPayload;
  const totalPages = Math.ceil(totalCount / pageSize);

  return (
    <div style={styles.footer}>
      <div>
        <select
          className="form-select form-select-sm"
          value={pageSize}
          onChange={(e) =>
            setInputPayload((prev) => ({
              ...prev,
              pageSize: Number(e.target.value),
              pageNumber: 1,
            }))
          }
        >
          {[10, 25, 50, 100].map((size) => (
            <option key={size} value={size}>
              {size} / page
            </option>
          ))}
        </select>
      </div>

      <div style={styles.pagination}>
        <button
          onClick={() => setInputPayload((prev) => ({ ...prev, pageNumber: 1 }))}
          disabled={pageNumber === 1}
        >
          <span className="ag-icon ag-icon-first"></span> First
        </button>

        <button
          onClick={() =>
            setInputPayload((prev) => ({
              ...prev,
              pageNumber: Math.max(prev.pageNumber - 1, 1),
            }))
          }
          disabled={pageNumber === 1}
        >
          <span className="ag-icon ag-icon-previous"></span> Prev
        </button>

        <p className="mb-0">
          Page {pageNumber} of {totalPages || 1}
        </p>

        <button
          onClick={() =>
            setInputPayload((prev) => ({
              ...prev,
              pageNumber: Math.min(prev.pageNumber + 1, totalPages),
            }))
          }
          disabled={pageNumber === totalPages}
        >
          Next <span className="ag-icon ag-icon-next"></span>
        </button>

        <button
          onClick={() =>
            setInputPayload((prev) => ({
              ...prev,
              pageNumber: totalPages,
            }))
          }
          disabled={pageNumber === totalPages}
        >
          Last <span className="ag-icon ag-icon-last"></span>
        </button>
      </div>
    </div>
  );
};

// Inline styles for the footer
const styles = {
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px',
    background: '#f8f9fa',
    borderTop: '1px solid #ccc',
    gap: '10px',
  },
  pagination: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
};

export default CustomPagination;
